// extracted by mini-css-extract-plugin
export default {"multiline":"multiline_multiline__gp93w"};